import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  EMPLOYEE_RESET_MFA_API_URL,
  EMPLOYEE_RESET_MFA_MUTATION_KEY,
  EMPLOYEES_EDIT_PERMISSIONS,
} from '@modules/employees/submodules/edit/constants';

export default function useEmployeeResetMfaMutation(): IContextMutationResult<void, Error, number> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, number>({
    mutationKey: [EMPLOYEE_RESET_MFA_MUTATION_KEY],
    mutationFn: (id) => fetchPost<void>(
      EMPLOYEE_RESET_MFA_API_URL,
      {},
      {
        permission: EMPLOYEES_EDIT_PERMISSIONS.CLEAR_GOOGLE_SECRET,
        urlParams: {
          id,
        },
      },
    ),
  });
}
